import { ReflectionDto } from './reflection.dto';

export class Reflection {
    readonly id: string;
    readonly name: string;
    readonly questionText: string;

    constructor(dto: ReflectionDto) {
        this.id = dto.id;
        this.name = dto.name ?? '';
        this.questionText = dto.questionText ?? '';
    }
}
